import React from "react";
import ButtonCell from "../buttons/ButtonCell";
import TextInputCell from "../gridCells/TextInputCell";

interface Props {
  started: boolean;
  dataTest: string;
  resetState: (started: boolean) => void;
  setItemName: (name: string) => void;
  setItemKey: (key: string) => void;
  typeName: string;
}

const FormWithNameAndKey: React.FC<Props> = ({
  typeName,
  dataTest,
  resetState,
  setItemName,
  setItemKey,
  started,
  children,
}) => {
  const handleNameChange = (event: any) => {
    setItemName(event.target.value);
  };
  const handleKeyChange = (event: any) => {
    setItemKey(event.target.value);
  };

  if (!started) {
    return (
      <ButtonCell
        buttonText={`Add new ${typeName}`}
        dataTest={`add-new-${dataTest}`}
        classes="grid-cell-fill"
        onClick={() => resetState(true)}
      />
    );
  }

  return (
    <>
      <ButtonCell
        key="cancel-add"
        buttonText={`Cancel add ${typeName}`}
        dataTest={`cancel-add-${dataTest}`}
        classes="grid-cell-fill"
        onClick={() => resetState(false)}
      />
      <TextInputCell
        dataTest={`name-input-${dataTest}`}
        placeholder={`${typeName} Name`}
        onChange={handleNameChange}
      />
      <TextInputCell
        dataTest={`key-input-${dataTest}`}
        placeholder="key"
        onChange={handleKeyChange}
      />
      {children}
    </>
  );
};

export default FormWithNameAndKey;
